import Layout from '@/layout/layout'

const insuranceSlip = {
    path: '/insuranceSlip',
    component: Layout,
    redirect: 'noRedirect',
    name: '投保推单',
    children: [
        {
            path: 'pushManage',
            component: () => import('@/views/insuranceSlip/pushManage/index'),
            name: '投保推单管理',
            meta: { title: '投保推单管理', noCache: true }
        },
    ]
}

export default insuranceSlip